import React, { useMemo } from "react";
import { useDispatch } from "react-redux";
import * as actions from "../../../../_redux/teacher-courses/TeacherCoursesAction";
import { resultAlert } from "../../../../../../../_helpers/Helpers";
import { 
  Card, 
  CardBody, 
  CardHeader,
  CardHeaderToolbar
} from "../../../../../../../_metronic/_partials/controls";
import { SectionAndCoursesFilter } from "./section-and-courses-filter/SectionAndCoursesFilter";
import { SectionsAndCoursesTable } from "./section-and-courses-table/SectionsAndCoursesTable";
import { useSectionsAndCoursesUIContext } from "./SectionsAndCoursesUIContext";

export function SectionsAndCoursesCard({ 
  history,
  teacherId,
  term
}) {
  // Sections And Courses Card UI Context
  const sectionsAndCoursesUIContext = useSectionsAndCoursesUIContext();
  const sectionsAndCoursesUIProps = useMemo(() => {
    return {
      ids: sectionsAndCoursesUIContext.ids
    };
  }, [sectionsAndCoursesUIContext]);

  // Sections And Courses Redux state
  const dispatch = useDispatch();
    
  /** Belli Bir Öğretmen Dersi Listesini Kaydeder */
  const saveTeacherCourses = (ids) => {
    dispatch(actions.saveTeacherCourses(teacherId, term, ids)).then(result => onResult(result));
  }  

  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => history.push("/ogretmen-dersleri"), 2500);
  };

  const title = <>Sınıf ve Ders Listesi{sectionsAndCoursesUIProps.ids.length > 0 ?
                  <> [Seçilen Kayıt Sayısı: <span style={{color:"red"}}>{sectionsAndCoursesUIProps.ids.length}</span>]</> :
                   ""}
                </>;

  return (
    <Card>
      <CardHeader title={title}>        
        <CardHeaderToolbar>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => saveTeacherCourses(sectionsAndCoursesUIProps.ids)}
          >
            Kaydet
          </button>           
        </CardHeaderToolbar>           
      </CardHeader>
      <CardBody>
        <SectionAndCoursesFilter />
        <SectionsAndCoursesTable />
      </CardBody>
    </Card>
  );
}